(function() {
  // Performance Patch for Palo Alto Theme 9.0.2
  // Fixes Forced Reflow and Layout Thrashing in theme.js
  // Version: 2.0 (Aggressive Mode)

  console.log('⚡️ Theme Performance Patch v2.0 Loaded');

  if (!window.theme) window.theme = {};

  // Debounce helper
  window.theme.debounce = window.theme.debounce || function(func, wait) {
    let timeout;
    return function() {
      const context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  };

  // Cache DOM elements
  let elements = {};
  function cacheElements() {
    elements = {
      body: document.body,
      header: document.querySelector('[data-header-height]'),
      footer: document.querySelector('[data-section-type*="footer"]'),
      announcementBar: document.querySelector('[data-announcement-bar]'),
      collectionStickyBar: document.querySelector('[data-collection-sticky-bar]'),
      stickyHeader: document.querySelector('[data-site-header][data-position="fixed"]'),
      main: document.querySelector('[data-main]'),
      logoTextLink: document.querySelector('[data-logo-text-link]')
    };
  }

  // Optimized readHeights
  let cachedHeights = {};
  let isResizePending = false;

  const optimizedReadHeights = function(forceUpdate = false) {
    if (!forceUpdate && Object.keys(cachedHeights).length > 0 && !isResizePending) {
      return cachedHeights;
    }

    // Refresh cache if needed
    if (Object.keys(elements).length === 0 || forceUpdate) cacheElements();

    const windowHeight = Math.min(window.screen.height, window.innerHeight);
    const footerHeight = elements.footer ? elements.footer.clientHeight : 0;
    const headerHeight = elements.header ? elements.header.clientHeight : 0;
    const stickyHeaderHeight = elements.stickyHeader ? window.stickyHeaderHeight || 0 : 0;
    
    let headerInitialHeight = 0;
    if (elements.header) {
      headerInitialHeight = parseInt(elements.header.dataset.height || elements.header.offsetHeight) || 0;
    }

    const announcementBarHeight = elements.announcementBar ? elements.announcementBar.clientHeight : 0;
    
    let collectionStickyBarHeight = 0;
    if (elements.collectionStickyBar) {
      if (elements.collectionStickyBar.hasAttribute('data-collection-sticky-bar')) {
        document.documentElement.style.setProperty('--collection-sticky-bar-height', 'auto');
      }
      collectionStickyBarHeight = elements.collectionStickyBar.clientHeight;
    }

    cachedHeights = {
      windowHeight,
      footerHeight,
      headerHeight,
      stickyHeaderHeight,
      headerInitialHeight,
      announcementBarHeight,
      collectionStickyBarHeight
    };

    isResizePending = false;
    return cachedHeights;
  };

  // Optimized setVars
  const optimizedSetVars = function() {
    // Read phase
    const heights = optimizedReadHeights(true);
    const isHeaderTransparent = window.isHeaderTransparent;
    const mainFirstChild = elements.main && elements.main.firstElementChild;
    const supportsTransparentHeader = mainFirstChild && mainFirstChild.classList.contains('supports-transparent-header');

    // Calculate values
    let contentFull = heights.windowHeight - heights.headerInitialHeight - heights.announcementBarHeight;
    if (isHeaderTransparent && supportsTransparentHeader) {
      contentFull = heights.windowHeight - heights.announcementBarHeight;
    }

    let fullHeight = heights.windowHeight;
    if (elements.stickyHeader) {
      fullHeight = heights.windowHeight - heights.stickyHeaderHeight;
    }

    const contentMin = heights.windowHeight - heights.headerHeight - heights.footerHeight;

    // Write phase (batched)
    requestAnimationFrame(() => {
      const docStyle = document.documentElement.style;
      docStyle.setProperty('--header-height', `${heights.headerHeight}px`);
      docStyle.setProperty('--header-sticky-height', `${heights.headerHeight}px`);
      docStyle.setProperty('--footer-height', `${heights.footerHeight}px`);
      docStyle.setProperty('--content-full', `${contentFull}px`);
      docStyle.setProperty('--content-min', `${contentMin}px`);
      docStyle.setProperty('--collection-sticky-bar-height', `${heights.collectionStickyBarHeight}px`);
      docStyle.setProperty('--full-height', `${fullHeight}px`);
    });
  };

  // Override functions immediately
  window.theme.readHeights = optimizedReadHeights;
  window.theme.setVars = optimizedSetVars;

  // Also override using Object.defineProperty to prevent subsequent overwrites
  try {
    Object.defineProperty(window.theme, 'readHeights', {
      value: optimizedReadHeights,
      writable: false,
      configurable: false
    });
    Object.defineProperty(window.theme, 'setVars', {
      value: optimizedSetVars,
      writable: false,
      configurable: false
    });
  } catch (e) {
    console.warn('Could not lock theme functions:', e);
  }

  // Debounced resize handler
  const handleResize = window.theme.debounce(function() {
    isResizePending = true;
    window.theme.setVars();
    document.dispatchEvent(new CustomEvent('theme:vars'));
  }, 100);

  window.addEventListener('resize', handleResize);
  
  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.theme.setVars);
  } else {
    window.theme.setVars();
  }

})();
